import { Button, Field, Input } from "@unizpay/ui";
import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";
import { StepCard } from "../StepChrome";
import type { Draft } from "../draft";

export function BusinessStep({
  draft,
  update,
  next,
  cancel,
}: {
  draft: Draft;
  update: (patch: Partial<Draft>) => void;
  next: () => void;
  cancel: ReactNode;
}) {
  return (
    <StepCard
      onSubmit={(e) => {
        e.preventDefault();
        if (draft.name.trim()) next();
      }}
      title="Name your business"
      description="A profile is one business with its own payments, payout wallet, API keys and team. You will be its owner."
      footer={
        <>
          {cancel}
          <Button type="submit" disabled={!draft.name.trim()}>
            Continue <ArrowRight aria-hidden="true" />
          </Button>
        </>
      }
    >
      <Field label="Business name" hint="Shown to payers on checkout. You can change it later.">
        {(p) => (
          <Input
            {...p}
            name="name"
            required
            maxLength={100}
            autoComplete="organization"
            placeholder="Acme Inc."
            value={draft.name}
            onChange={(e) => update({ name: e.target.value })}
            autoFocus
          />
        )}
      </Field>
    </StepCard>
  );
}
